import { Image } from 'react-native';
import createAnimatedComponent from '../../createAnimatedComponent';

const AnimatedImage = createAnimatedComponent(Image as any);

export default AnimatedImage;
